const envUtil = {
  STAGE: process.env.REACT_APP_STAGE || "",
  IS_DEV: process.env.REACT_APP_STAGE !== "production",
  BASE_URL: process.env.REACT_APP_BASE_URL || "",
  RECAPTCHA_KEY: process.env.REACT_APP_RECAPTCHA_KEY || "",
  ENCRYPT_KEY: process.env.REACT_APP_ENCRYPT_KEY || "",
};

export default envUtil;
